import r from "./internal/_arity.mjs";
import e from "./internal/_pipe.mjs";
import t from "./reduce.mjs";
import m from "./tail.mjs";
function p() {
  if (arguments.length === 0)
    throw new Error("pipe requires at least one argument");
  return r(arguments[0].length, t(e, arguments[0], m(arguments)));
}
export {
  p as default
};
